<template>
  <div class='daka_con'>
    <div class='pub_top_block w_1200 famous_pub_top_block'>
      <dl>
        <dt>
          <h3>{{ $t('home.experts.detail.title') }}</h3>
        </dt>
      </dl>
      <img class='bg famous_banner' src='@/assets/img/photo_lector@2x.png' alt=''>
    </div>
    <div class='famous_sub_title hide'>{{ $t('home.experts.detail.subTitle') }}</div>
    <ul class='item_box w_1200'>
      <li v-for='(item, index) in list' :key='index' :class='["item fz_0", `item${index + 1}`]'>
        <dl class='dis_ib ver_t'>
          <dt class='img_box'><img :src='item.image' alt=''></dt>
          <dd>
            <div class='name'>{{ item.name }}</div>
            <div class='info'>{{ item.desc }}</div>
          </dd>
        </dl>
        <div class='text_box dis_ib ver_t'>
          <div class='info' v-html='item.intro'></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import test from '@/assets/img/test.png'
import { setTitle } from 'utils'
import { listHandler } from '@/utils/variable'
export default {
  name: 'BigShot',
  data () {
    return {
      test,
    }
  },
  computed: {
    list () {
      // 不根据语言版切换的初始数据
      let list = [
        {
          image: require('@/assets/img/Rectangle Copy 8@2x.png'),
          url: '/talkingPen',
        },
        {
          image: require('@/assets/img/Rectangle@2x.png'),
          url: '/listenEnglish',
        },
        {
          image: require('@/assets/img/test.png'),
          url: '/highFive',
        },
      ]
      // 结合语言版本进行初始化数据
      return listHandler.call(this, list, 'home.experts.detail.list')
    },
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('home.experts.info.title')}`)
  },
}
</script>
<style lang='less' scoped>
.daka_con .item .info p {
  text-indent: 35px;
}
</style>
